import React, { FunctionComponent } from 'react';

// Libs
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Api
import { findMostViewed } from '@Libs/api/cms/posts';

// Components
import PostCard from '@Pages/bai-viet/Components/PostCard';
import DownloadApp from '@Pages/bai-viet/Components/DownloadApp';
import CategoryCard from '@Pages/bai-viet/Components/Categories';

// Styles
import styles from './BannerRight.module.scss';

interface BannerRightProps {
    className?: string;
}

const BannerRight: FunctionComponent<BannerRightProps> = ({ className }) => {
    const { deviceType } = useViewDetected();

    const query = {
        limit: 5,
        start: 0,
    };
    const { data: mostViewed } = findMostViewed(query.start, query.limit);

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);
    return (
        <div className={wrapperClassName}>
            <CategoryCard className={styles.category_wrapper} />

            <PostCard title={'Xem nhiều nhất'} posts={mostViewed} className={styles.post_card} />

            <DownloadApp />
        </div>
    );
};

BannerRight.defaultProps = {
    className: '',
};

export default BannerRight;
